import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shopping-bag-3"} maskId="square-filled-radius-0-stroke-1-IconShoppingBag3"><path fillRule="evenodd" clipRule="evenodd" d="M17 3H7V7H3V21H21V7H17V3ZM16 7V12H17V7H16ZM8 7V12H7V7H8ZM8 7H16V4H8V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShoppingBag3;
